import { render, staticRenderFns } from "./student-details.vue?vue&type=template&id=f17dec80&scoped=true&"
import script from "./student-details.vue?vue&type=script&lang=js&"
export * from "./student-details.vue?vue&type=script&lang=js&"
import style0 from "./student-details.vue?vue&type=style&index=0&id=f17dec80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17dec80",
  null
  
)

export default component.exports